// GlobalErrorHandler.js
import { analytics, logEvent } from './firebase';

export const initGlobalErrorHandler = () => {
    // Global JS errors
    window.onerror = function (message, source, lineno, colno, error) {
        console.error('Web Global JS Error:', message, source, lineno, colno, error);

        logEvent(analytics, 'web_global_error', {
            message: message?.toString(),
            source: source || '',
            lineno,
            colno,
            stack: error?.stack || '',
        });
    };

    // Unhandled promise rejections
    window.onunhandledrejection = function (event) {
        console.error('Web Unhandled Promise Rejection:', event.reason);

        logEvent(analytics, 'web_unhandled_promise_rejection', {
            message: event.reason?.message || event.reason?.toString() || 'Unknown',
            stack: event.reason?.stack || '',
        });
    };
};